'use client';

import { useEffect } from 'react';

const MAIN_SCROLL_SELECTOR = 'main.app-scroll-container';

/** Mirrors modal scroll-lock on `<html>` onto the app `<main>` scroll container. */
export function AppScrollContainerSync() {
  useEffect(() => {
    const html = document.documentElement;

    const syncMainScrollLock = () => {
      const main = document.querySelector(MAIN_SCROLL_SELECTOR);
      if (!(main instanceof HTMLElement)) {
        return;
      }

      const locked = html.style.overflow === 'hidden';
      main.style.overflowY = locked ? 'hidden' : 'auto';
    };

    const observer = new MutationObserver(syncMainScrollLock);
    observer.observe(html, { attributes: true, attributeFilter: ['style'] });
    syncMainScrollLock();

    return () => observer.disconnect();
  }, []);

  return null;
}
